import { render } from "./PodftAsideModalClient.vue?vue&type=template&id=03037ccc"
import script from "./PodftAsideModalClient.vue?vue&type=script&lang=js"
export * from "./PodftAsideModalClient.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__